import {useCallback} from 'react';
import {deleteNorafUpdate} from 'api/agentNoraf';
import {useGetTokens} from 'services/auth';

export const useDeleteNorafUpdate = () => {
  const getTokens = useGetTokens();

  return useCallback(
    (id: string, mock?: boolean) => {
      return deleteNorafUpdate(getTokens, id, mock);
    },
    [getTokens],
  );
};
